module.exports = __webpack_public_path__ + "static/media/Roller Derby Girl.eaa9d076.jpg";